module.exports = __webpack_public_path__ + "static/media/mail-blue.f2a0d791.svg";